import React, { useState, useEffect } from 'react';
import { Box, Container, IconButton, Typography, Fab, Grid } from '@mui/material';
import { LinkedIn as LinkedInIcon, Instagram as InstagramIcon, Google as GoogleIcon, Twitter as TwitterIcon, Facebook as FacebookIcon, ArrowUpward as ArrowUpwardIcon } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

// import LogoImg from '../../assets/clinical-visuals-logo.png';
// import LogoImg  from "../../assets/clinical-visuals-logo-white.png"
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const LogoImg = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";
interface footerProps {
  className?: string;
}

const Footer: React.FC<footerProps> = ({ className }) => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [showScroll]);


  return (
    <Grid container  sx={{padding:"2% 6% 1%", backgroundColor:'#e9e9e9'}} className='footer'>
      <Grid item lg={3} md={3} sm={12} xs={12} sx={{ padding: "0% 2%" }} className='footer_grid'>
      <Box
            sx={{
              mr: 2,
              color: 'inherit',
              textDecoration: 'none',
              width: 200, // Set your desired width
              height: 60, // Set your desired height
              '@media (max-width: 600px)': {
                width: 150, // Responsive width for smaller screens
                height: 45, // Responsive height for smaller screens
              },
            }}
            component="img"
          src={LogoImg}
          alt='Clinical Visuals'
            className='footer_logo'
          />
      </Grid>

      <Grid item lg={3} md={3}  sm={12} xs={12} sx={{ padding: "0% 2%" }} className='footer_grid'>
        <Typography variant='h4' className='footer_heading'>Address</Typography>
        <Typography variant='h5' className='comp_title' sx={{ fontSize:'1.2rem', paddingTop:'10px', fontWeight:'600'}}>Clinical Visuals</Typography>
        <Box >
          Clinical Visulas Address
        </Box>
        <Box sx={{paddingTop:'10px'}}> Email : <a href='/' >test@gmail.com</a></Box>
      </Grid>

      <Grid item lg={3} md={3}  sm={12} xs={12} sx={{ padding: "0% 2%" }} className='footer_grid'>
        <Typography variant='h4' className='footer_heading'>Quick Links</Typography>
        <MenuList className='menu_list'>
          <MenuItem className='menu_list_item'>
            <NavLink to="/about-us" className='menu_list_link'>Support</NavLink>
          </MenuItem>
          <MenuItem className='menu_list_item'>
            <NavLink to="/portfolio" className='menu_list_link'>Terms & Conditions</NavLink>
          </MenuItem>
          <MenuItem className='menu_list_item'>
            <NavLink to="/careers" className='menu_list_link'>Privacy Policy</NavLink>
          </MenuItem>
          <MenuItem className='menu_list_item'>
            <NavLink to="/blog" className='menu_list_link'>Map</NavLink>
          </MenuItem>
        </MenuList>
      </Grid>

      <Grid item lg={3} md={3}  sm={12} xs={12} sx={{ padding: "0% 2%" }} className='footer_grid'>
        <Typography variant='h4' className='footer_heading'>Follow Us</Typography>
        <Box
          className={className}
          component="footer"
          sx={{
            textAlign: 'center',
            color: 'white',
            paddingTop: 1,
            position: 'relative'
          }}
        >        
            <Box mb={0} className="social_icons" sx={{display:"flex"}}>
                <IconButton
                sx={{ color: 'dark', margin: 0, }}
              >
                <FacebookIcon fontSize="medium" />
              </IconButton>
              <IconButton
                sx={{ color: 'dark', margin: 0 }}
              >
                <TwitterIcon fontSize="medium" />
              </IconButton>
              <IconButton
                sx={{ color: 'dark', margin: 0 }}
              >
                <GoogleIcon fontSize="medium" />
              </IconButton>
              <IconButton

                sx={{ color: 'dark', margin: 0 }}
              >
                <InstagramIcon fontSize="medium" />
              </IconButton>
              <IconButton
                sx={{ color: 'dark', margin: 0 }}
              >
                <LinkedInIcon fontSize="medium" />
              </IconButton>
            </Box>

        {showScroll && (
          <Fab
            className='scroll_top'
            color="primary"
            size="small"
            onClick={scrollTop}
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              zIndex: 1000,
              backgroundColor: 'dark', 
              '&:hover': {
                backgroundColor: 'dark' 
              }
            }}
          >
            <ArrowUpwardIcon />
          </Fab>
        )}
      </Box>
      </Grid>
      
      
      <Grid item lg={12} md={12} sm={12} xs={12}>      
        <Box
          className={className}
          component="footer"
          sx={{
            textAlign: 'center',
            color: 'white',
            paddingTop: 1,
            position: 'relative'
          }}
        >
        <Container>        
            <Box mb={0} className="social_icons">
             
              <Box>
                <Typography variant="caption" sx={{ marginTop: 2 }}>
                  &copy; {new Date().getFullYear()} All rights reserved.
                </Typography>
              </Box>
            </Box>
          </Container>

        {showScroll && (
          <Fab
            className='scroll_top'
            color="primary"
            size="small"
            onClick={scrollTop}
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              zIndex: 1000,
              backgroundColor: 'dark', 
              '&:hover': {
                backgroundColor: 'dark' 
              }
            }}
          >
            <ArrowUpwardIcon />
          </Fab>
        )}
      </Box>
    </Grid>
    </Grid>
  );
};

export default Footer;
